$(function () {
  const acc = $('.hs-benefits-right-sdie-content-accordian');
  const bodies = acc.find('.hs-benefits-right-sdie-content-accordian-description-area');

  bodies.hide();                 // Hide all by default
  acc.removeClass('active');     // Remove active class from all

  acc.on('click', '.hs-benefits-right-sdie-content-accordian-title-area', function () {
    const item = $(this).parent();
    const body = item.find('.hs-benefits-right-sdie-content-accordian-description-area');

    if (item.hasClass('active')) {
      item.removeClass('active');
      body.slideUp(200);
    } else {
      acc.removeClass('active');
      bodies.slideUp(200);
      item.addClass('active');
      body.slideDown(200);
    }
  });
});


$(document).ready(function () {
  $(".hs-product-qa-left-side-questioniar-title-block").click(function () {
    
    let parent = $(this).closest(".hs-product-qa-left-side-questioniar");
    let answer = parent.find(".hs-product-qa-left-side-questioniar-answer-block");

    // Close all others
    $(".hs-product-qa-left-side-questioniar-answer-block").not(answer).slideUp();
    $(".hs-product-qa-left-side-questioniar").not(parent).removeClass("active");

    // Toggle current
    answer.slideToggle();
    parent.toggleClass("active");
  });
});

// document.addEventListener('DOMContentLoaded', function() {
//   var recommendation_slider = new Swiper(".hs-product-recommendation-slider", {
    
//     slidesPerView: 4,
//     spaceBetween: 32,

//     navigation: {
//       nextEl: ".hs-product-recommendation-slider-next-btn",
//       prevEl: ".hs-product-recommendation-slider-pre-btn",
//     },

//     breakpoints: {
//       320: {
//         slidesPerView: 1,
//         spaceBetween: 20
//       },
//       576: {
//         slidesPerView: 2,
//         spaceBetween: 20
//       },
//       992: {
//         slidesPerView: 3,
//         spaceBetween: 24
//       },
//       1200: {
//         slidesPerView: 4,
//         spaceBetween: 32
//       }
//     }

//   });
// });

document.addEventListener('DOMContentLoaded', function() {
  var recommendation_slider = new Swiper(".hs-product-recommendation-slider", {
    
    slidesPerView: 4,
    spaceBetween: 60,

    navigation: {
      nextEl: ".hs-product-recommendation-slider-next-btn",
      prevEl: ".hs-product-recommendation-slider-pre-btn",
    },

    breakpoints: {
      0: {
        slidesPerView: 1,
        spaceBetween: 20
      },
      820: {
        slidesPerView: 2,
        spaceBetween: 40
      },
      1024: {
        slidesPerView: 3,
        spaceBetween: 40
      },
      1281: {
        slidesPerView: 4,
        spaceBetween: 40
      }
    }

  });
});



document.addEventListener('DOMContentLoaded', function() {
  document.addEventListener('product-recommendations:loaded', function() {
    if (window.yotpo && window.yotpo.refreshWidgets) {
      window.yotpo.refreshWidgets();
    }
  });
});


$(document).ready(function() {

  $('.hs-ingredients-right-side-accordian-title-block').click(function () {

    let parent = $(this).closest('.hs-ingredients-right-side-accordian');
    let content = parent.find('.hs-ingredients-right-side-accordian-des-block');

    // Close all others
    $('.hs-ingredients-right-side-accordian-des-block').not(content).slideUp();
    $('.hs-ingredients-right-side-accordian').not(parent).removeClass('active');

    // Toggle current
    parent.toggleClass('active');
    content.stop(true, true).slideToggle();

  });

});


var thumbSwiper = new Swiper(".hs-product-info-slidershow-thumbs-swiper", {
  direction: "vertical",
  spaceBetween: 12,
  slidesPerView: 5,
  freeMode: true,
  watchSlidesProgress: true,
});

var mainSwiper = new Swiper(".hs-product-info-slidershow-main-swiper", {
  spaceBetween: 10,
  thumbs: {
    swiper: thumbSwiper,
  },
  navigation: {
    nextEl: ".hs-product-info-main-next",
    prevEl: ".hs-product-info-main-prev",
  }, 

  // Responsive breakpoints
  breakpoints: {
    1281: {
      slidesPerView: 1,
      spaceBetween: 0,
    },
    1025: {
      slidesPerView: 2,
    },
    0: {
      slidesPerView: 1, // Default for mobile/tablet
      spaceBetween: 0,
    }
  }
});




document.addEventListener("DOMContentLoaded", () => {

  const qtyBlocks = document.querySelectorAll(".hs-product-info-content-product-quantity-block");

  qtyBlocks.forEach(block => {

    const minusBtn = block.querySelector(".pre-quantity-btn");
    const plusBtn  = block.querySelector(".next-quantity-btn");
    const qtyInput = block.querySelector(".input-quantity");

    if (!qtyInput) return;

    // --- Helper Function: Force Shopify to update immediately ---
    const updateValue = (newVal) => {
      qtyInput.value = newVal;
      qtyInput.setAttribute("value", newVal); // fixes Shopify overwrites
      qtyInput.dispatchEvent(new Event("input", { bubbles: true }));
      qtyInput.dispatchEvent(new Event("change", { bubbles: true }));
    };

    // --- Decrease ---
    minusBtn.addEventListener("click", (e) => {
      e.preventDefault();
      let val = parseInt(qtyInput.value) || 1;
      if (val > 1) updateValue(val - 1);
    });

    // --- Increase ---
    plusBtn.addEventListener("click", (e) => {
      e.preventDefault();
      let val = parseInt(qtyInput.value) || 1;
      updateValue(val + 1);
    });

    // --- Prevent negative or zero ---
    qtyInput.addEventListener("input", () => {
      if (qtyInput.value < 1) updateValue(1);
    });

  });
});

// document.addEventListener("DOMContentLoaded", () => {

//   const variantButtons = document.querySelectorAll(".variant-btn");
//   const variantIdInput = document.querySelector(".variant-id");

//   if (!variantIdInput) return;

//   variantButtons.forEach(btn => {
//     btn.addEventListener("click", () => {

//       const variantId = btn.getAttribute("data-variant-id");

//       // Update selected class
//       variantButtons.forEach(b => b.classList.remove("selected"));
//       btn.classList.add("selected");

//       // Update hidden input value for Add to Cart
//       variantIdInput.value = variantId;
//       variantIdInput.setAttribute("value", variantId);

//       // Force Shopify to detect change
//       variantIdInput.dispatchEvent(new Event("change", { bubbles: true }));
//     });
//   });

// });

document.addEventListener("DOMContentLoaded", initVariantButtons);

function updateVariantUrl(variantId) {
  if (!variantId) return;

  const url = new URL(window.location.href);

  url.searchParams.set("variant", variantId);

  window.history.replaceState(
    window.history.state,
    "",
    url.toString()
  );
}

function initVariantButtons() {
  const section = document.querySelector(".hs-product-info-block");

  if (!section) return;

  const variantButtons = section.querySelectorAll(".variant-btn");

  const variantIdInput = section.querySelector(
    "[data-product-variant-input]"
  );

  const gallery = section.querySelector(
    ".hs-product-info-slidershow-main-swiper"
  );

  if (!variantIdInput || !variantButtons.length) return;

  function switchVariantImage(imageId) {
    if (!imageId || !gallery || !gallery.swiper) return;

    const slides = Array.from(
      gallery.querySelectorAll(
        ".hs-product-info-slidershow-main-slide"
      )
    );

    const imageIndex = slides.findIndex(
      slide => slide.dataset.imageId === imageId
    );

    if (imageIndex === -1) return;

    gallery.swiper.slideTo(imageIndex, 350);
  }

function updateVariantPrice(button) {
  const purchaseWrapper = section.querySelector(
    "[data-product-purchase-wrapper]"
  );

  const atcButton = section.querySelector(
    "[data-product-atc]"
  );

  if (!purchaseWrapper || !atcButton) return;

  // const originalPrice = button.dataset.variantPrice;
  const originalPrice = `$${button.dataset.variantPrice}`;
  const discountPercent = parseFloat(
    purchaseWrapper.dataset.ecoDiscount || "0"
  );

  if (!originalPrice) return;

  // Preserve the existing sold-out state.
  if (button.dataset.variantAvailable === "false") {
    atcButton.textContent = "SOLD OUT";
    return;
  }

  if (discountPercent > 0) {
    const rawNumber = originalPrice.replace(/[^0-9.]/g, "");
    const discountedNumber =
      parseFloat(rawNumber) * (1 - discountPercent / 100);

    const discountedPrice = originalPrice.replace(
      rawNumber,
      discountedNumber.toFixed(2)
    );

    atcButton.innerHTML = `
      ADD TO CART -
      <span class="ecp-btn-price">${discountedPrice}</span>
      <span class="ecp-btn-original"
        style="text-decoration:line-through;opacity:0.7;margin-left:5px;">
        ${originalPrice}
      </span>
    `;
  } else {
    atcButton.textContent = `ADD TO CART - ${originalPrice} USD`;
  }
}

  variantButtons.forEach(button => {
    button.addEventListener("click", () => {
      const variantId = button.dataset.variantId;
      const imageId = button.dataset.imageId;

      variantButtons.forEach(item => {
        item.classList.remove("selected");
      });

      button.classList.add("selected");

      variantIdInput.value = variantId;

      variantIdInput.dispatchEvent(
        new Event("change", { bubbles: true })
      );

      switchVariantImage(imageId);

      // Update the URL to match the selected variant
      updateVariantUrl(variantId);

      // Update the Add to Cart price.
      updateVariantPrice(button);
    });
  });
}


$(document).ready(function () {

  $(".hs-image-and-text-text-col-accordian-title-block").on("click", function () {

    let parent = $(this).closest(".hs-image-and-text-text-col-accordian");
    let content = parent.find(".hs-image-and-text-text-col-accordian-des-block");

    // Close all other accordions
    $(".hs-image-and-text-text-col-accordian-des-block").not(content).slideUp();
    $(".hs-image-and-text-text-col-accordian").not(parent).removeClass("active");

    // Toggle current one
    content.slideToggle();
    parent.toggleClass("active");
  });

});

document.addEventListener("DOMContentLoaded", () => {
  const tooltipBtn = document.querySelector(".tool-tip");
  const customTooltip = document.querySelector(".custom-tool-tip");

  if (tooltipBtn && customTooltip) {

    // Toggle on button click
    tooltipBtn.addEventListener("click", (e) => {
      e.stopPropagation(); // stop click from reaching document
      customTooltip.classList.toggle("active");
    });

    // Close tooltip when clicking outside
    document.addEventListener("click", (e) => {
      if (!customTooltip.contains(e.target) && !tooltipBtn.contains(e.target)) {
        customTooltip.classList.remove("active");
      }
    });

  }
});


$(document).ready(function() {
    $('.hs-benefits-right-sdie-content-features-accordian-title-area').on('click', function() {
        const $parent = $(this).closest('.hs-benefits-right-sdie-content-features-accordian');
        const $content = $parent.find('.hs-benefits-right-sdie-content-features-accordian-description-area');

        // If the clicked item is already open, close it
        if ($parent.hasClass('active')) {
        $content.slideUp();
        $parent.removeClass('active');
        } else {
        // Close all other accordions in this grid
        $('.hs-benefits-right-sdie-content-features-accordian').removeClass('active');
        $('.hs-benefits-right-sdie-content-features-accordian-description-area').slideUp();

        // Open the clicked one
        $parent.addClass('active');
        $content.slideDown();
        }
    });
});


$(document).ready(function() {
    $('.hs-ingredients-v2-accordian-title-arrow-block').on('click', function() {
        const $parent = $(this).closest('.hs-ingredients-v2-accordian');
        const $content = $parent.find('.hs-ingredients-v2-accordian-image-text-block');

        // If the clicked item is already open, close it
        if ($parent.hasClass('active')) {
        $content.slideUp();
        $parent.removeClass('active');
        } else {
        // Close all other accordions in this grid
        $('.hs-ingredients-v2-accordian').removeClass('active');
        $('.hs-ingredients-v2-accordian-image-text-block').slideUp();

        // Open the clicked one
        $parent.addClass('active');
        $content.slideDown();
        }
    });
});


// Reviews Button
// PageFly Yotpo Reviews Fix
document.addEventListener('click', function (e) {

  // Only run on PageFly pages
  if (!document.querySelector('#__pf')) {
    return;
  }

  const reviewButton = e.target.closest(
    '.yotpo-sr-bottom-line-button'
  );

  if (!reviewButton) {
    return;
  }

  console.log('✅ PageFly review button clicked');


  const reviewTab = document.querySelector(
    '.target-review-tab'
  );

  console.log('Review tab found:', reviewTab);


  if (reviewTab) {

    reviewTab.click();

    console.log('✅ Review tab opened');


    setTimeout(function () {

      const reviewsSection = document.querySelector(
        '#yotpo-reviews-main-widget'
      );

      console.log(
        'Reviews section:',
        reviewsSection
      );


      if (reviewsSection) {

        reviewsSection.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });

        console.log('✅ Scrolled to reviews');

      } else {

        console.log('❌ Reviews widget not found');

      }

    }, 800);

  } else {

    console.log('❌ Review tab not found');

  }

});

